var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seat-details"},[_c('span',{staticClass:"fa fa-chair pr-1 seat-icon"}),_vm._v(" "),_c('span',{staticClass:"seat-details__text"},[(_vm.selectedContractName)?_c('div',{staticClass:"spot-name"},[_vm._v(_vm._s(_vm.selectedContractName))]):_vm._e(),_vm._v("\n    "+_vm._s([
      _vm.formattedDaysPerWeek,
      _vm.daysOfWeek,
      _vm.hoursFromTo,
      _vm.formattedCost
    ].filter(Boolean).join('  •  '))+"\n    "),_c('div',{staticClass:"spot-starting-at"},[_vm._v(_vm._s(_vm.startingAt))]),_vm._v(" "),(!_vm.legupId)?_c('div',{staticClass:"spot-created-at"},[_vm._v(_vm._s(_vm.createdDate))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }